import {InjectionToken} from '@angular/core';

export const AGENT_AUTH_BASE_URL = new InjectionToken<string>(
    'Base Url for Agent Auth Api', {
      providedIn: 'root',
      factory: () => 'localhost',
    },
);

export const AGENT_AUTH_REALM = new InjectionToken<string>(
    'Expected realm claim for agent auth', {
      providedIn: 'root',
      factory: () => '',
    },
);
